import { api } from './client';

export interface Session {
  id: string;
  company_id: string | null;
  title: string;
  current_step: number;
  status: string;
  api_provider: string | null;
  created_at: string;
  updated_at: string;
}

export async function listSessions(params?: {
  status?: string;
  page?: number;
  limit?: number;
}): Promise<{ data: Session[]; total: number }> {
  const qs = new URLSearchParams();
  if (params?.status) qs.set('status', params.status);
  if (params?.page) qs.set('page', String(params.page));
  if (params?.limit) qs.set('limit', String(params.limit));
  const q = qs.toString();
  return api.get(`/sessions${q ? `?${q}` : ''}`);
}

export async function getSession(id: string): Promise<Session> {
  return api.get(`/sessions/${id}`);
}

export async function createSession(data: {
  title: string;
  company_id: string;
}): Promise<Session> {
  return api.post('/sessions', data);
}

export async function updateSession(
  id: string,
  data: Partial<Pick<Session, 'title' | 'current_step' | 'status'>>
): Promise<Session> {
  return api.patch(`/sessions/${id}`, data);
}

export async function deleteSession(id: string): Promise<void> {
  return api.delete(`/sessions/${id}`);
}

// ── Companies helper (needed for session creation) ──────────────

export interface Company {
  id: string;
  company_name: string;
}

export async function listCompanies(): Promise<{ data: Company[]; total: number }> {
  return api.get('/companies');
}
